export const config = {
  id: process.env.REACT_APP_MERCHANT_ID
};
